import { Navigate, Route, Routes } from "react-router";

import { AppShell } from "@/components/app-shell";
import {
  AdminRoute,
  CustomerRoute,
  ProtectedRoute,
  WorkforceRoute,
} from "@/components/protected-route";
import { AdminAccountsPage } from "@/features/admin/accounts";
import { AdminAccountDetailPage } from "@/features/admin/accounts/detail";
import { AdminActivityPage } from "@/features/admin/activity";
import { AdminMcpInsightsPage } from "@/features/admin/mcp";
import { AdminUsersPage } from "@/features/admin/users";
import { HomePage } from "@/features/home";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { PortalHome } from "@/features/portal";
import { PortalApprovalsPage } from "@/features/portal/approvals";
import { PortalPermissionsPage } from "@/features/portal/permissions";
import { ProfilePage } from "@/features/profile";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/login" element={<LoginPage />} />
      {/* All authenticated pages share the AppShell (sidebar + topbar). The
          shell renders inside ProtectedRoute, so it only mounts when signed in;
          AdminRoute nests further to gate the admin-only pages. */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          {/* J&J workforce workspace — customers are bounced to /portal. */}
          <Route element={<WorkforceRoute />}>
            <Route path="/home" element={<HomePage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route element={<AdminRoute />}>
              <Route path="/admin/users" element={<AdminUsersPage />} />
              <Route path="/admin/activity" element={<AdminActivityPage />} />
              <Route path="/admin/mcp" element={<AdminMcpInsightsPage />} />
              <Route path="/admin/accounts" element={<AdminAccountsPage />} />
              <Route path="/admin/accounts/:accountId" element={<AdminAccountDetailPage />} />
            </Route>
          </Route>
          {/* Customer self-service portal — workforce users are bounced to /home. */}
          <Route element={<CustomerRoute />}>
            <Route path="/portal" element={<PortalHome />} />
            <Route path="/portal/permissions" element={<PortalPermissionsPage />} />
            <Route path="/portal/approvals" element={<PortalApprovalsPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
